var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: 16px;\n  margin-bottom: 16px;\n  padding-left: 0px;\n  padding-right: 0px;\n  text-align: ', ';\n  h3 {\n    margin-top: 16px;\n    margin-bottom: 16px;\n    @media (max-width: 768px) {\n      padding-left: 24px;\n      padding-right: 24px;\n    }\n  }\n  br {\n    @media (max-width: 768px) {\n      display: none;\n    }\n  }\n'], ['\n  margin-top: 16px;\n  margin-bottom: 16px;\n  padding-left: 0px;\n  padding-right: 0px;\n  text-align: ', ';\n  h3 {\n    margin-top: 16px;\n    margin-bottom: 16px;\n    @media (max-width: 768px) {\n      padding-left: 24px;\n      padding-right: 24px;\n    }\n  }\n  br {\n    @media (max-width: 768px) {\n      display: none;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject, function (props) {
  return props.alignment || 'center';
});

var Heading = function Heading(props) {
  return React.createElement(Container, {
    alignment: props.alignment
  }, React.createElement('h3', null, props.children));
};

export default Heading;